import {FlexPage} from '@hconnect/common/components'
import {Grid, useMediaQuery, useTheme} from '@mui/material'

type LayoutProps = {
  titleSlot?: React.ReactNode
  operationHoursSlot: React.ReactNode
  eventsSlot: React.ReactNode
  revisionCodesSlot: React.ReactNode
  kilnDowntimeByCategorySlot: React.ReactNode
  upcomingStoppagesSlot: React.ReactNode
  rcfaSummarySlot: React.ReactNode
}

export const MajorOutageLeadDashboardLayout: React.FC<LayoutProps> = ({
  titleSlot,
  operationHoursSlot,
  eventsSlot,
  revisionCodesSlot,
  kilnDowntimeByCategorySlot,
  upcomingStoppagesSlot,
  rcfaSummarySlot
}) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const spacing = isMobile ? 1 : 2

  return (
    <FlexPage title={titleSlot} nameHeaderSx={{mt: titleSlot ? 0 : undefined}}>
      <Grid container spacing={spacing} height={'100%'}>
        <Grid item xs={12} sm={6} lg={3}>
          {revisionCodesSlot}
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          {kilnDowntimeByCategorySlot}
        </Grid>
        <Grid item xs={12} sm={12} lg={6}>
          {operationHoursSlot}
        </Grid>

        {isDesktop ? (
          <>
            <Grid item xs={12} sm={6} lg={3}>
              {rcfaSummarySlot}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              {upcomingStoppagesSlot}
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              {eventsSlot}
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sm={12} lg={6}>
              {eventsSlot}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              {rcfaSummarySlot}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              {upcomingStoppagesSlot}
            </Grid>
          </>
        )}
      </Grid>
    </FlexPage>
  )
}
